module.exports = __webpack_public_path__ + "static/media/up-arrow-8.f0baf3b2.svg";